module.exports = __webpack_public_path__ + "static/media/OS4.4a875ebb.jpg";